<!-- 项目信息 -->
<template>
  <div>
    <k-form-build
      :value="jsonData"
      ref="KFB"
    />
  </div>
</template>
<script>
export default {
  name: 'ProjectProtocolNumber',
  data() {
    return {
      jsonData: {
        'list': [
          {
            'type': 'input',
            'icon': 'icon-edit',
            'options': {
              'width': '100%',
              'minRows': 4,
              'maxRows': 6,
              'maxLength': null,
              'defaultValue': '',
              'clearable': false,
              'hidden': false,

              'placeholder': '访视次数'
            },
            'model': 'f601d260-4eb9-3c94-79b6-cf7af731790e',
            'key': 'f601d260-4eb9-3c94-79b6-cf7af731790e',
            'rules': [
              {
                'required': false,
                'message': '必填项'
              }
            ]
          }
        ],
        'config': {
          'layout': 'vertical',
          'labelCol': {
            'span': 4
          },
          'wrapperCol': {
            'span': 18
          },
          'hideRequiredMark': false,
          'customStyle': ''
        }
      }
    }
  },
  methods: {},
  mounted() {

  }
}
</script>
